import gql from 'graphql-tag'

export const CREATE_PAPER = gql`
  mutation CreatePaper($uuid: ID!, $content: JSON!, $filename: String!) {
    createPaper(uploadUuid: $uuid, content: $content, filename: $filename) {
      uploadUuid
    }
  }
`

export const DELETE_PAPER = gql`
  mutation DeletePaper($uuid: ID!) {
    deletePaper(uploadUuid: $uuid)
  }
`

export const UPDATE_PAPER = gql`
  mutation UpdatePaper($uuid: ID!, $content: JSON!) {
    updatePaper(uploadUuid: $uuid, content: $content) {
      uploadUuid
    }
  }
`

export const GET_PAPER = gql`
  query GetPaper($uuid: ID!) {
    getPaper(uploadUuid: $uuid) {
      content
      filename
      feedbacks {
        feedbackId
        feedbackType
        updatedAt
        feedbackContent {
          feedbackInApp
          feedbackAvailable
          feedbackIsValid
          feedbackIsPartial
          feedbackNote
          dueDate
          feedback {
            criterion
            content
            score
            omittedCharacterLength
          }
        }
      }
    }
  }
`

export const GET_GLIMPSE = gql`
  query GetGlimpse($submissionId: ID!, $glimpseId: ID!) {
    getGlimpse(submissionId: $submissionId, glimpseId: $glimpseId) {
      glimpse_id
      text
      match_segments
    }
  }
`

export const GET_SUBJECT = gql`
  query GetPaperSubject($paper: String!) {
    getPaperSubjectPrediction(paper: $paper, includeMetadata: true) {
      subject
      score
      kgName
      kgUuid
      metadata {
        modelVersion
        apiSignature
        apiName
        apiVersion
        apiDisplayName
        modelVariant
        serviceVariant
        modelCheck
      }
    }
  }
`

export const GET_PAPERS = gql`
  query GetPapers {
    getPapers(limit: 100, orderBy: updatedAt, order: desc, page: 1) {
      uploadUuid
      filename
      updatedAt
    }
  }
`

export const GET_PAPER_FEEDBACK_COUNT = gql`
  query GetPaperFeedbackCount {
    getPaperFeedbackCount
  }
`



// WEBPACK FOOTER //
// ./src/queries/Papers.ts